import { DiagnosticsService } from '@/services/abstract/DiagnosticsService';
import type { BrowserInfo, StorageEstimate } from '@/types/Diagnostics';

const EMPTY_STORAGE_ESTIMATE: StorageEstimate = { usageBytes: 0, quotaBytes: 0 };

export class DiagnosticsServiceImpl extends DiagnosticsService {
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this -- implements abstract contract; no instance state needed
  async getStorageEstimate(): Promise<StorageEstimate> {
    const storage = navigator.storage as StorageManager | undefined;
    if (storage?.estimate === undefined) {
      return EMPTY_STORAGE_ESTIMATE;
    }

    const estimate = await storage.estimate();
    return {
      usageBytes: estimate.usage ?? 0,
      quotaBytes: estimate.quota ?? 0,
    };
  }

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this -- implements abstract contract; no instance state needed
  getBrowserInfo(): BrowserInfo {
    return {
      userAgent: navigator.userAgent,
      language: navigator.language,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      online: navigator.onLine,
    };
  }
}
